function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m16.324 6.497c-.413-.909-1.325-1.497-2.324-1.497s-1.911.588-2.324 1.497l-3.676 9.313v1.19c0 3.309 2.691 6 6 6s6-2.691 6-6.049c0-.757-.141-1.498-.418-2.203zm-2.324 14.503c-2.206 0-4-1.794-4-4v-.81l3.505-8.884c.189-.378.843-.325.979-.029l3.237 8.204c.185.471.279.965.279 1.519 0 2.206-1.794 4-4 4z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m63 33v-2c0-1.103-.897-2-2-2v-13c0-3.859-3.141-7-7-7h-5c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2h-6c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2h-5.003c-1.963-4.693-6.6-8-11.997-8-7.168 0-13 5.832-13 13s5.832 13 13 13c5.397 0 10.034-3.307 11.997-8h5.003c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2h6c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2h2v10c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2v2h-4c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2h-5v-4h1c1.654 0 3-1.346 3-3s-1.346-3-3-3h-1c0-2.206-1.794-4-4-4s-4 1.794-4 4h-1c-1.654 0-3 1.346-3 3s1.346 3 3 3h1v4h-5c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2h-5c-3.859 0-7 3.141-7 7v7c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2v6h10v-6c1.103 0 2-.897 2-2v-2c0-1.103-.897-2-2-2v-4h2c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2h18c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2h4v4c-1.103 0-2 .897-2 2v2c0 1.103.897 2 2 2v6h10v-6c1.103 0 2-.897 2-2v-2c0-1.103-.897-2-2-2v-16c1.103 0 2-.897 2-2zm-49-8c-6.065 0-11-4.935-11-11s4.935-11 11-11 11 4.935 11 11-4.935 11-11 11zm12.637-8c.229-.965.363-1.966.363-3s-.134-2.035-.363-3h4.363v6zm6.363 2v-10h2l.002 10zm4-2v-6h6v6zm-24 44h-6v-4h6zm2.002-6h-10.002v-2h10zm-.002-10c-1.103 0-2 .897-2 2v4h-6v-7c0-2.757 2.243-5 5-5h5v6zm17-20c1.103 0 2 .897 2 2h-4c0-1.103.897-2 2-2zm-6 5c0-.552.448-1 1-1h10c.552 0 1 .448 1 1s-.448 1-1 1h-10c-.552 0-1-.448-1-1zm4 3h4v4h-4zm-11 14v-10h2l.002 10zm4-2v-6h18v6zm22-26v-10h2l.002 10zm6-2h-2v-6h5c2.757 0 5 2.243 5 5v13h-6v-10c0-1.103-.897-2-2-2zm0 14h10l.002 2h-10.002zm-8 16v-10h2l.002 10zm4-2v-6h4v6zm12 16h-6v-4h6zm2.002-6h-10.002v-2h10zm-2.002-4h-6v-16h6z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m55 39h2v2h-2z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m55 47h2v2h-2z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m55 43h2v2h-2z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m33 41h2v2h-2z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m25 41h2v2h-2z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m29 41h2v2h-2z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m55 25h2v2h-2z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m55 17h2v2h-2z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m55 21h2v2h-2z"
});

function SvgPipeline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipeline);
export default __webpack_public_path__ + "static/media/pipeline.1396fe54.svg";
export { ForwardRef as ReactComponent };